import { createContext } from 'react';

import type { useReducerState } from '../hooks/useReducerState';

export const stateContext = createContext<ReturnType<typeof useReducerState>>({} as ReturnType<typeof useReducerState>);

export const StateProvider = stateContext.Provider;
